"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var go = require("gojs/release/go");
var NodeLabelDraggingTool = (function (_super) {
    __extends(NodeLabelDraggingTool, _super);
    function NodeLabelDraggingTool() {
        var _this = _super.call(this) || this;
        _this.name = 'NodeLabelDragging';
        _this.label = null;
        _this._offset = new go.Point();
        _this._originalAlignment = null;
        _this._originalCenter = null;
        return _this;
    }
    NodeLabelDraggingTool.prototype.canStart = function () {
        if (!go.Tool.prototype.canStart.call(this))
            return false;
        var diagram = this.diagram;
        if (diagram === null)
            return false;
        var e = diagram.lastInput;
        if (!e.left)
            return false;
        if (!this.isBeyondDragSize())
            return false;
        return this.findLabel() !== null;
    };
    NodeLabelDraggingTool.prototype.findLabel = function () {
        var diagram = this.diagram;
        var e = diagram.firstInput;
        var elt = diagram.findObjectAt(e.documentPoint, null, null);
        if (elt === null || !(elt.part instanceof go.Node))
            return null;
        if (elt.part instanceof go.Node) {
            elt.part.isSelected = true;
        }
        while (elt.panel !== null) {
            if (elt._isNodeLabel && elt.panel.type === go.Panel.Spot && elt.panel.findMainElement() !== elt)
                return elt;
            elt = elt.panel;
        }
        return null;
    };
    NodeLabelDraggingTool.prototype.doActivate = function () {
        this.startTransaction('Shifted Label');
        this.label = this.findLabel();
        if (this.label !== null) {
            this._offset = this.diagram.firstInput.documentPoint.copy().subtract(this.label.getDocumentPoint(go.Spot.Center));
            this._originalAlignment = this.label.alignment.copy();
            if (this.label !== null && this.label.panel !== null) {
                var main = this.label.panel.findMainElement();
                if (main !== null) {
                    this._originalCenter = main.getDocumentPoint(go.Spot.Center);
                }
            }
        }
        go.Tool.prototype.doActivate.call(this);
    };
    NodeLabelDraggingTool.prototype.doDeactivate = function () {
        go.Tool.prototype.doDeactivate.call(this);
        this.stopTransaction();
    };
    NodeLabelDraggingTool.prototype.doStop = function () {
        this.label = null;
        go.Tool.prototype.doStop.call(this);
    };
    NodeLabelDraggingTool.prototype.doCancel = function () {
        if (this.label !== null && this._originalAlignment !== null) {
            var node = this.label.part;
            this.diagram.model.set(node.data, 'labelAlignment', this._originalAlignment);
        }
        go.Tool.prototype.doCancel.call(this);
    };
    NodeLabelDraggingTool.prototype.doMouseMove = function () {
        if (!this.isActive)
            return;
        this.updateAlignment();
    };
    NodeLabelDraggingTool.prototype.doMouseUp = function () {
        if (!this.isActive)
            return;
        this.updateAlignment();
        this.transactionResult = 'Shifted Label';
        this.stopTool();
    };
    NodeLabelDraggingTool.prototype.updateAlignment = function () {
        if (this.label === null)
            return;
        var last = this.diagram.lastInput.documentPoint;
        var cntr = this._originalCenter;
        if (cntr !== null) {
            var align = new go.Spot(0.5, 0.5, last.x - this._offset.x - cntr.x, last.y - this._offset.y - cntr.y);
            var node = this.label.part;
            this.diagram.model.set(node.data, 'labelAlignment', align);
        }
    };
    return NodeLabelDraggingTool;
}(go.Tool));
exports.NodeLabelDraggingTool = NodeLabelDraggingTool;
